import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";
import storageSession from "redux-persist/lib/storage/session";
import authSlice from "../slices/auth.slice";
import moduleSlice from "../slices/module.slice";
import tableSlice from "../slices/table.slice";
import medicationSlice from "../slices/ehr/medication.slice";
import documentSlice from "../slices/ehr/document.slice";
import vaccinationSlice from "../slices/ehr/vaccination.slice";
import patientChartingSlice from "../slices/ehr/patientCharting.slice";
import chargeAndTaxSlice from "../slices/admin/charges.slice";
import schedulingSlice from "../slices/ehr/scheduling.slice";
import visitNoteSlice from "../slices/ehr/visitnote.slice";
import statusConfigurationSlice from "../slices/ehr/statusConfiguration.slice";
import addCreditDrawer from "../slices/employer/addCreditDrawer.slice";
import convertMembershipSlice from "../slices/employer/converMembership.slice";
import onlineSignUpSlice from "../slices/employer/onlineSignup.slice";
import taskReducer from "../slices/ehr/task.slice";
import employerSlice from "../slices/employer/employer.slice";
import stripeSlice from "../slices/stripe/stripe.slice";
import activityHistoryDrawerSlice from "../slices/employer/activityHistoryDrawerSlice";
import invoiceSlice from "../slices/invoice/invoice.slice";
import notificationSlice from "../slices/notification.slice";
import templateSlice from "../slices/templates/template.slice";
import messagingSlice from "../slices/messaging/messaging.slice";
import navbarProviderSlice from "../slices/ehr/navbarProvider.slice";

const visitNotePersistConfig = {
  key: "visitNote",
  storage: storageSession,
};

const rootPersistConfig = {
  key: "root",
  storage,
  whitelist: [
    "auth",
    "module",
    "medication",
    "employer",
    "stripe",
    "invoice",
    "messaging",
  ],
};

const rootReducer = combineReducers({
  auth: authSlice,
  module: moduleSlice,
  table: tableSlice,
  patientCharting: patientChartingSlice,
  medication: medicationSlice,
  document: documentSlice,
  vaccination: vaccinationSlice,
  chargeAndTax: chargeAndTaxSlice,
  scheduling: schedulingSlice,
  visitNote: persistReducer(visitNotePersistConfig, visitNoteSlice),
  statusConfiguration: statusConfigurationSlice,
  creditDrawer: addCreditDrawer,
  convertMembershipDrawer: convertMembershipSlice,
  onlineSignup: onlineSignUpSlice,
  task: taskReducer,
  employer: employerSlice,
  stripe: stripeSlice,
  activityHistoryDrawer: activityHistoryDrawerSlice,
  invoice: invoiceSlice,
  notification: notificationSlice,
  templates: templateSlice,
  messaging: messagingSlice,
  navbarProvider: navbarProviderSlice,
});

const persistedReducer = persistReducer(rootPersistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export const persistor = persistStore(store);
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
